const PlusIcon = ({ size = 13, color = "#2d2d2d" }: { size?: number; color?: string }) => {
    return (
        <svg
            stroke={color}
            strokeWidth="2.3"
            viewBox="0 0 24 24"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ height: size, width: size }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
    );
};

export default PlusIcon;
